import axios from "axios";

export const CepService = {
    get: (cep:string) => {
        const viaCepUrl = `https://viacep.com.br/ws/${cep}/json`;
        return axios.get(viaCepUrl);
    },
}